import { NavigateBackLink } from '@exam-center/components';
import { ProctorRequestStatusLabel } from '@exam-center/proctor-management';
import { Flex, PageHeader, Text } from '@shared/components';

import { useProctorRequestDetails } from '../../providers';

import { getProctorRequestHeaderDetails } from './utils';

export default function ProctorRequestHeader() {
  const { proctorRequest } = useProctorRequestDetails();

  const { fullName, refCode, status, examCenter, lastModifiedAt, lastModifiedBy, requestedAt } =
    getProctorRequestHeaderDetails(proctorRequest);

  return (
    <PageHeader
      title={fullName}
      endAdornment={<ProctorRequestStatusLabel variant={status} />}
      subtitleSection={
        <Flex
          sx={{
            justifyContent: 'space-between',
            flex: 1,
          }}
        >
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2' color='text.secondary'>
              เลขที่คำขอ: {refCode}
            </Text>
            <Text variant='body2' color='text.secondary'>
              ศูนย์ทดสอบ: {examCenter}
            </Text>
            {requestedAt ? (
              <Text variant='body2' color='text.secondary'>
                วันที่ส่งคำขอ: {requestedAt}
              </Text>
            ) : null}
          </Flex>
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2' color='text.secondary'>
              Last Modified: {lastModifiedAt}
            </Text>
            <Text variant='body2' color='text.secondary'>
              By: {lastModifiedBy}
            </Text>
          </Flex>
        </Flex>
      }
      linkAdornment={
        <NavigateBackLink
          to='/:examCenterCode/exam-proctors/requests'
          params={{ examCenterCode: proctorRequest.examCenterCode }}
        />
      }
    />
  );
}
